import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { APICore } from '../../helpers/api/apiCore';
import { getFranchisesSuccess, getFranchisesError } from './actions';
import { FranchiseActionTypes } from './constants';

const api = new APICore();

function* getFranchises(): SagaIterator {
    try {
        const response = yield call(api.get, '/franchises', {});
        const data = response.data || response;
        yield put(getFranchisesSuccess(Array.isArray(data) ? data : []));
    } catch (error: any) {
        yield put(getFranchisesError(error));
    }
}

export function* watchGetFranchises() {
    yield takeEvery(FranchiseActionTypes.GET_FRANCHISES, getFranchises);
}

function* franchiseSaga() {
    yield all([fork(watchGetFranchises)]);
}

export default franchiseSaga;
